import { render, staticRenderFns } from "./huamingce.vue?vue&type=template&id=34283f39&scoped=true&"
import script from "./huamingce.vue?vue&type=script&lang=js&"
export * from "./huamingce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34283f39",
  null
  
)

export default component.exports